module.exports = {
    Lang: {
        de: 'Deutsch',
        en: 'Englisch',
        es: 'Spanisch',
        fr: 'Französisch',
        pt: 'Portugiesisch',
        it: 'Italienisch',
        ru: 'Russisch'
    },
    Action: {
        add: 'Hinzufügen',
        edit: 'Bearbeiten',
        remove: 'Auftrag löschen',
        close: 'Schließen',
        select: 'Auswählen',
        save: 'Speichern',
        saving: 'Wird gespeichert',
        send: 'Senden',
        confirmSelection: 'Auswahl bestätigen',
        change: 'Ändern',
        changeSelection: 'Auswahl ändern',
        next: 'Weiter',
        prev: 'Zurück',
        finish: 'Fertig',
        'search': 'Suche'
    },
    Common: {
        start: 'Start',
        date: 'Datum',
        creationdate: 'Erstellungsdatum',
        lastmodified: 'Letzte Änderung',
        status: 'Status',
        color: 'Farbe',
        settings: 'Einstellungen',
        masterdata: 'Stammdaten',
        masterdataSaved: 'Stammdaten wurden gespeichert',
        amount: 'Betrag',
        description: 'Beschreibung',
        item: 'Artikel',
        itemNum: 'Artikel Nr.',
        itemName: 'Artikelname',
        itemPrice: 'Artikelpreis',
        quantity: 'Anzahl',
        singlePrice: 'Einzelpreis',
        discount: 'Nachlass',
        rebate: 'Rabatt',
        vat: 'MwSt.',
        total: 'Gesamt',
        orderPrice: 'Bestellpreis',
        annotation: 'Anmerkung',
        accountDetails: 'Kundendaten',
        customerNum: 'Kundennummer',
        salutation: 'Anrede',
        firstname: 'Vorname',
        lastname: 'Nachname',
        company: 'Firma',
        email: 'E-Mail',
        contact: 'Anschrift',
        address: 'Adresse',
        postalcode: 'PLZ',
        city: 'Stadt',
        country: 'Land',
        taxDetails: 'Steuerdaten',
        vatId: 'USt.-ID Nr.',
        noEntries: 'Keine Einträge',
        languageSettings: 'Spracheinstellungen',
        showXtoYentries: 'Zeige {x} bis {y} Ergebnisse',
        showXtoYofZentries: 'Zeige {x} bis {y} von {z} Ergebnissen',
        errorSavingMasterdata: 'Stammdaten konnten nicht gespeichert werden.',
        errorIncomplete: 'Formular unvollständig',
        errorFieldMissing: '{field} muss ausgefüllt sein',
        errorUploadInvalidResp: 'Ungültige Server-Antwort. Bitte versuchen Sie es erneut oder wenden Sie sich an unseren Support.'
    },
    Units: {
        C62: 'Stk',
        GRM: 'g'
    },
    Dashboard: {
        title: 'Dashboard'
    },
    Addresses: {
        title: 'Adressen',
        add: 'Neue Adresse',
        addressMain: 'Hauptanschrift',
        addressBilling: 'Rechnungsanschrift',
        addressShipping: 'Lieferanschrift',
        confirmRemove: 'Wollen Sie den Kontakt wirklich entfernen?',
        errorLoad: 'Adressen konnten nicht geladen werden.',
        errorRemove: 'Adresse konnte nicht gelöscht werden.'
    },
    EditAddress: {
        title: 'Neue Adresse',
        errorTypeTitle: 'Bitte legen Sie einen Adresstypen fest.',
        errorTypeText: 'Die Anschrift muss eine Liefer- und/oder eine Rechnungsanschrift sein.',
        errorCreate: 'Adresse konnte nicht angelegt werden.',
        errorUpdate: 'Adresse konnte nicht aktualisiert werden.',
        shipping: 'Lieferungen',
        useForShippingNo: 'Nicht als Lieferanschrift verwenden',
        useForShippingYes: 'Als Lieferanschrift verwenden',
        useForShippingDefault: 'Als Standard-Lieferanschrift verwenden',
        billing: 'Rechnungen',
        useForBillingNo: 'Nicht als Rechnungsanschrift verwenden',
        useForBillingYes: 'Als Rechnungsanschrift verwenden',
        useForBillingDefault: 'Als Standard-Rechnungsanschrift verwenden'
    },
    Projects: {
        title: 'Reports',
        loading: 'Reports werden geladen',
        currentProjects: 'Aktuelle Reports',
        showAll: 'Alle Reports anzeigen',
        noProjects: 'Keine Reports',
        add: 'Neuer Report',
        projectNumber: 'Report Nr.',
        projectName: 'Patienten ID',
        projectType: 'Report typ',
        statusAll: 'Alle Reports',
        statusOpen: 'Offene Reports',
        statusOrdered: 'Bestellte Reports',
        errorNoName: 'Bitte geben Sie einen Reportnamen ein',
        errorCreate: 'Report konnte nicht angelegt werden.',
        errorCouldNotLoad: 'Reports konnten nicht geladen werden'
    },
    ProjectDetails: {
        title: 'Bestelldetails',
        loading: 'Report wird geladen',
        alertOrdered: 'Report bestellt:',
        openOrder: 'Bestellung öffnen',
        alertReference: 'Dieses Projekt ist mit einem anderen Projekt verknüpft:',
        openProject: 'Report öffnen',
        toothSelection: 'Zahnauswahl',
        noConstruction: 'Keine Konstruktion festgelegt!',
        editConstruction: 'Kontruktion bearbeiten',
        materialSelection: 'Materialauswahl',
        estimatedDelivery: 'Vorauss. Lieferdatum',
        missingMaterial: 'Materialauswahl fehlt',
        missingAttachments: 'Fehlende Anhänge',
        addStl: 'STL hinzufügen',
        openCart: 'Zum Warenkorb',
        emptyCart: 'Warenkorb leer',
        shippingType: 'Versandart',
        construction: 'Konstruktion',
        stlUpload: 'STL Upload',
        attachments: 'Anhänge',
        addons: 'Zusatzprodukte',
        cart: 'Warenkorb',
        addItem: 'Artikel hinzufügen',
        orderProject: 'Verbindlich bestellen',
        statusNotOrdered: 'Noch nicht bestellt',
        statusOrdered: 'Bestellt',
        errorNoProjectnum: 'Keine gültige Reportnummer übergeben'
    },
    Orders: {
        title: 'Bestellungen',
        loading: 'Bestellungen werden geladen',
        currentOrders: 'Aktuelle Bestellungen',
        openOrder: 'Bestellung öffnen',
        showAll: 'Alle Bestellungen anzeigen',
        noOrders: 'Keine Bestellungen',
        orderNum: 'Auftrag Nr.',
        projectRef: 'Projektreferenz',
        statusAll: 'Alle Bestellungen',
        errorCouldNotLoad: 'Bestellungen konnten nicht geladen werden'
    },
    Reports: {
        statusAll: 'Alle Reports',
        statusReceived: 'Daten bereitgestellt',
        statusReceivedDescr: 'Bestellung wird geprüft',
        statusInProgress: 'In Bearbeitung',
        statusInProgressDescr: 'Ihre Daten werden verarbeitet',
        statusInProduction: 'Berichtsvorlage erstellt',
        statusInProductionDescr: 'Ihre Berichtsvorlage ist erstellt',
        statusOnHold: 'Gehalten',
        statusCancelled: 'Storniert',
        statusCancelledDescr: 'Ihre Bestellung wurde storniert',
        statusClosed: 'Report generiert',
        statusCompleted: 'Report generiert',
        statusCompletedDescr: 'Sie haben Ihren Bericht generiert',
        statusInvoicedCancelled: 'Teilberechnet / Storniert',
        statusPartlyDelivered: 'Teilgeliefert',
        statusPartlyDeliveredCancelled: 'Teilgeliefert / Storniert',
        statusPartlyDeliveredClosed: 'Teilgeliefert / Geschlossen',
        statusDelivered: 'Report generiert',
        statusDeliveredDescr: 'Ihr Bericht ist vollständig',
        statusReadyForPickup: 'Abholbereit',
    },
    OrderDetails: {
        title: 'Bestelldetails',
        deliveryNote: 'Lieferschein',
        loading: 'Bestellung wird geladen',
        trackingNum: 'Tracking Nr.',
        manufacturingStatus: 'Fertigungsstatus',
        trackingAndBilling: 'Tracking und Abrechnung',
        creatingOrder: 'Bestellung wird erstellt',
        orderProject: 'Verbindlich bestellen',
        placeOrder: 'Bestellung abschließen',
        acceptTerms: 'Ich habe die <a href="{termsUrl}" target="_blank">Allgemeinen Geschäftsbedingungen</a> gelesen und akzeptiert.',
        errorNoOrderNum: 'Keine gültige Bestellnummer übergeben',
        errorCouldNotLoad: 'Bestellung konnte nicht geladen werden',
        priceNobleMetal1: 'Der Endgültige Produktpreis ist bei Edelmetallen vom endgültigen Gewicht abhängig.',
        priceNobleMetal2: 'Bitte prüfen Sie hierzu Ihren Lieferschein, sobald der Auftrag abgeschlossen ist.',
        files: 'Dateien'
    },
    Messages: {
        title: 'Nachrichten',
        noMessages: 'Keine Nachrichten',
        errorCouldNotLoad: 'Nachrichten konnte nicht geladen werden',
        writeSomething: 'Schreiben Sie was...',
        errorSendingMessage: 'Nachricht konnte nicht gesendet werden.'
    },
    Configurator: {
        selectIndication: 'Indikation wählen',
        changeMaterial: 'Material ändern',
        selectTooth: 'Bitte wählen Sie einen Zahn',
        showToothNumbers: 'Zahnnummern anzeigen',
        toothSelection: 'Zahnauswahl',
        setProductProps: 'Produkteigenschaften festlegen',
        selectProduct: 'Produkt wählen',
        fileXofY: 'Datei {x} von {y}',
        calcPrice: 'Preise werden berechnet',
        uploadStl: 'STL hochladen',
        stlCount: 'Einheitenanzahl der obigen STL',
        stlCountTooltip: 'Bitte Einheitenanzahl der STL-Datei angeben, z.B. 3 Einheiten bei dreigliedriger Brücke',
        oneUnit: 'Eine Einheit',
        nUnits: '{n} Einheiten',
        removeJawSelection: 'Wollen sie die bestehende Auswahl in diesem Kiefer entfernen?',
        invalidTeethInRange: 'The {0} teeth is invalid for range {1}-{2}.',
        invalidRange: 'The {0}-{1} tooth range is invalid. The start/end teeth have to be on the same jaw.',
        invalidTeethNumber: 'The {0} is invalid teeth number.',
        transferSettings: 'Do you want to transfer those settings to multiple teeth?',
        clickOnConnectTooth: 'Click on the tooth you want to connect to'
    },
    Invoices: {
        title: 'Rechnungen',
        loading: 'Rechnungen werden geladen',
        invoiceNum: 'Rechnung Nr.',
        monthlyStatement: 'Monatsaufstellung',
        statusReceived: 'Eingegangen',
        statusOpen: 'Offen',
        statusHold: 'Gehalten',
        statusCancelled: 'Storniert',
        statusClosed: 'Geschlossen',
        statusPartlyPaid: 'Teilbezahlt',
        statusPartlyPaidCancelled: 'Teilbezahlt / Storniert',
        statusPartlyPaidClosed: 'Teilbezahlt / Geschlossen',
        statusPaid: 'Bezahlt'
    },
    File: {
        name: 'Dateiname',
        hash: 'Dateihash',
        size: 'Dateigröße',
        messageUpload: 'Zum Upload klicken oder Datei auf das Feld ziehen',
        allFilesSameMaterial: 'Alle Dateien haben das gleiche Material',
        sendingData: 'Daten werden übermittelt',
        processingData: 'Daten werden verarbeitet',
        errorUpload: 'Es ist ein Fehler aufgetreten. Die Datei konnte leider nicht hochgeladen werden.',
        errorCouldNotList: 'Dateien konnten nicht geladen werden.',
        errorCouldNotLoad: 'Datei konnte nicht geladen werden.',
        errorCouldNotDelete: 'Datei konnte nicht entfernt werden.'
    },
    Login: {
        username: 'E-Mail oder Kundennummer',
        password: 'Passwort',
        passwordOld: 'Altes Passwort',
        passwordNew: 'Neues Passwort',
        passwordConfirm: 'Neues Passwort bestätigen',
        passwordSaved: 'Passwort gespeichert',
        login: 'Login',
        logout: 'Logout',
        enterPwd: 'Bitte geben Sie ein Passwort ein',
        invalidUserOrPwd: 'Ungültiger Benutzername/Passwort',
        errorCouldNotUpdate: 'Passwort konnte nicht gespeichert werden.',
        errorPasswordNoMatch: 'Passwörter stimmen nicht überein.',
        errorOldPassword: 'Das alte Passwort ist falsch.',
        errorNoSession: 'Keine Benutzersession gefunden. Bitte melden Sie sich an.'
    }
};
